import { Button } from '@approvalmax/ui';
import { Flex, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { xeroConstants } from 'modules/common/constants';
import { domain } from 'modules/data';
import React, { memo, ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'services/localization';
import { routingService } from 'services/routing';

import { Root, StyledAlertIcon } from './ReviewerV1SupportingBanner.styles';

export const ReviewerV1SupportingBanner = memo(() => {
    const companies = useSelector(selectors.company.companiesSelector);
    const showBanner = useMemo(() => {
        return companies.some(
            ({ betaFeatures, flags }) =>
                betaFeatures.includes(domain.CompanyBetaFeature.ReviewerV1) &&
                (flags.isAccountOwner || flags.isManager || flags.isWorkflowManager)
        );
    }, [companies]);

    const learnMore = () => {
        routingService.navigateToExternalUrlInNewTab(xeroConstants.XERO_REVIEWER_V1_MIGRATION_LINK);
    };

    if (!showBanner) return null;

    return (
        <Root height={62} spacing='12 28'>
            <Flex>
                <Flex direction='column' justifyContent='space-between' grow={1} spacing='0'>
                    <Flex alignItems='center' spacing='8'>
                        <StyledAlertIcon height={20} />

                        <Text font='body' color='white100' fontSize='medium'>
                            {t('the_old_reviewer_feature_for_xero_bills_was_retired_on_july', {
                                b: (chunks: ReactNode) => <b>{chunks}</b>,
                            })}
                        </Text>

                        <StyledAlertIcon height={20} />
                    </Flex>

                    <Text font='body' color='white100' fontSize='small'>
                        {t('to_retain_review_and_editing_functionality_migrate_to_the_editing_on_approval_feature', {
                            b: (chunks: ReactNode) => <b>{chunks}</b>,
                        })}
                    </Text>
                </Flex>

                <Flex alignItems='center'>
                    <Button fontSize='small12' colorTheme='white' theme='secondary' execute={learnMore}>
                        {t('learn_more')}
                    </Button>
                </Flex>
            </Flex>
        </Root>
    );
});

ReviewerV1SupportingBanner.displayName = 'ReviewerV1SupportingBanner';
